import React, { useEffect, useState } from "react";

function Countdown({ text, textStyle, seconds, secondsStyle }) {
  const [timeLeft, setTimeLeft] = useState(seconds);

  useEffect(() => {
    if (timeLeft <= 0) return;

    const interval = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft]);

  const formatTime = seconds => {
    if (seconds <= 0) return "Expirado!";
    
    const days = Math.floor(seconds / (24 * 60 * 60));
    const hours = Math.floor((seconds % (24 * 60 * 60)) / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    if (days > 0) {
      const dayLabel = days === 1 ? "dia" : "dias";
      const hourLabel = hours === 1 ? "hora" : "horas";
      return `${days} ${dayLabel} e ${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")} ${hourLabel}`;
    }
    if (hours > 0) {
      const hourLabel = hours === 1 ? "hora" : "horas";
      return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")} ${hourLabel}`;
    }
    const minLabel = mins === 1 ? "minuto" : "minutos";
    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")} ${minLabel}`;
  };

  return (
    <div className="d-flex justify-content-center">
      {text && <h2 style={textStyle}>{text}</h2>}
      <p className="mb-0" style={secondsStyle}>
        {formatTime(timeLeft)}
      </p>
    </div>
  );
}

export default Countdown;
